import { commonGetters } from '@/util/store-helpers';
import { uniq } from 'lodash';

export function withBlacklistedBy(state, getters, rootState, rootGetters) {
   const blacklists = rootGetters['companies/blacklistedZips'];
   return state.zips.map(zip => {
      const code = parseInt(zip.zip, 10);
      const blacklisted_by = blacklists[code] || [];
      return {
         ...zip,
         blacklisted_by,
      };
   });
}

export function areas(state) {
   return uniq(state.zips.map(zip => zip.area)
      .sort());
}

export function regions(state) {
   return uniq(state.zips.map(zip => zip.region)
      .sort());
}

const getters = commonGetters('zips', 'zip');

export const {
   all, loaded, find, query, get, exists,
} = getters;
